import { FormatType, getFormatter } from '@revelio/replots';

/**
 * Relative "time since posted" label, e.g. "today", "1 day ago", "5 days ago".
 * Returns '' for missing/invalid dates. Callers add any prefix they need — the
 * detail popout renders "Posted {…}", the card list shows it bare in a meta row.
 */
export const relativePostedAt = (isoDateTime: string): string => {
  const posted = new Date(isoDateTime).getTime();
  if (Number.isNaN(posted)) return '';
  const diffMs = Date.now() - posted;
  const days = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));
  if (days === 0) return 'today';
  if (days === 1) return '1 day ago';
  return `${days} days ago`;
};

/**
 * Rounded/abbreviated salary label matching Talent Discovery + the posting table
 * (e.g. "$60.5k a year"). Salary values must already be in the target currency.
 * Pass min=0 for a single-value salary.
 */
export const formatSalaryRange = (
  min: number,
  max: number,
  currencyCode: string
): string => {
  const fmt = getFormatter(FormatType.CURRENCY, { currencyCode });
  if (!min && max) return `${fmt(max)} a year`;
  if (min <= 0 && max <= 0) return '';
  if (min === max) return `${fmt(min)} a year`;
  return `${fmt(min)} - ${fmt(max)} a year`;
};
